import React, { Component } from 'react';
import { UIView} from 'ui-router-react'; 
import { CSSTransitionGroup } from 'react-transition-group'; 
import Submenu from '../components/Submenu'; 

class InformationContainer extends Component {
	render() {		   
		   return (
				<div>
					<Submenu menuName="informationen" menuItems={this.props.resolves.menuItems} />
					<UIView render={(Comp, props) =>
					  <CSSTransitionGroup
						transitionName="example"
						transitionEnterTimeout={250}
						transitionLeaveTimeout={250}>
						<Comp {...props} key={props.transition} />
					  </CSSTransitionGroup>
					}/>
				</div>
			)
	   
	}
}
export default InformationContainer;


// WEBPACK FOOTER //
// ./src/containers/InformationContainer.js